import React, { useState, useEffect, useContext } from "react";
import LogoActions from "./LogoActions";
import { LogoContext } from "../../contexts/LogoContext";

const LogoDropdown = () => {
  const [select, setSelect] = useState("typed");
  const {dispatch} = useContext(LogoContext);
  useEffect(() => {
    dispatch({ type: 'UPDATE_DROPDOWN', dropdown: select});
  }, [select])
  return (
      <div>
        <div className="logoDropdown">
          <label htmlFor="logoDropdown" style={{ display: "none" }}></label>
          <select id="logoDropdown" name="logoDropdown" onChange={(e) => setSelect(e.target.value)}>
              <option value="typed">Typed</option>
              <option value="local">Upload</option>
              <option value="web">URL</option>
          </select>
        </div>
        <LogoActions select={select}/>
      </div>
  );
};

export default LogoDropdown;
